module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-100-thin-a59cd57bebd41b6c43cce86f87da3c55.woff2";